module.exports = __webpack_public_path__ + "media/images/icons/filled/chrome-672476423a837a5e7f2e66a513a36bd4.svg";